


// class ComboPage {
//   constructor() {
//     this.combo = [];
//     this.maxSlots = 3;
//     this.minimumItems = 3;
//     this.discountPercentage = 20;
//     this.tierPrice = 0;
//     this.currentTierId = null;
//     this.discountCode = '';
//     this.footer = document.querySelector('.combo-footer');
//     this.checkoutBtn = document.querySelector('.combo-checkout-btn');
//     this.totalPriceEl = document.querySelector('.js-combo-total');
//     this.totalLabelEl = document.querySelector('.js-combo-total-label');
//     this.slotsContainer = document.querySelector('.combo-slots');
//     this.isCheckingOut = false;
//     this.init();
//   }

//   async init() {
//     // 1. Fetch current cart and sync combo state (Replacing the cart clear logic to prevent replacement)
//     await this.syncWithCart();

//     this.bindAtbButtons(document);

//     this.setupInfiniteScroll();
//     this.setupFilterListeners();

//     if (this.checkoutBtn) {
//       this.checkoutBtn.addEventListener('click', (e) => {
//         e.preventDefault();
//         this.handleCheckout();
//       });
//     }

//     document.querySelectorAll('.js-tier-tab').forEach(btn => {
//       btn.addEventListener('click', (e) => this.handleTabClick(e.currentTarget));
//     });

//     this.applyTierSettings(this.getActiveTierElement());
//     this.updateUI();
//     this.watchCartForComboDiscount();

//     // Load real filters from collection URL for each tier (filters only available on collection pages)
//     document.querySelectorAll('.js-combo-tier').forEach(tier => this.loadFiltersForTier(tier));

//     // Auto-select a product if redirected from PDP via ?autoselect=handle
//     this.handleAutoSelect();
//   }

//   async syncWithCart() {
//     try {
//       const res = await fetch('/cart.js');
//       const cart = await res.json();
//       this.setGlobalCartCount(cart.item_count);

//       // Filter items that belong to the combo
//       this.combo = cart.items
//         .filter(item => item.properties && item.properties._combo === 'true')
//         .map(item => ({
//           productId: String(item.product_id),
//           variantId: String(item.variant_id),
//           price: item.price,
//           image: item.image,
//           title: item.product_title,
//           handle: item.handle
//         }));

//       // Try to identify the tier from the first item found to lock it
//       if (this.combo.length > 0) {
//         const firstId = this.combo[0].variantId;
//         const btn = document.querySelector(`.js-atb-btn[data-variant-id="${firstId}"]`);
//         if (btn) {
//           const tier = btn.closest('.combo-tier');
//           if (tier) this.currentTierId = tier.dataset.tierId;
//         }
//       }
//     } catch (e) {
//       console.error('Failed to sync with cart', e);
//     }
//   }

//   handleAutoSelect() {
//     const params = new URLSearchParams(window.location.search);
//     const handle = params.get('autoselect');
//     if (!handle) return;

//     // If already in combo, don't trigger another click (which would remove it)
//     if (this.combo.some(item => item.handle === handle)) {
//       const cleanUrl = window.location.pathname;
//       window.history.replaceState({}, '', cleanUrl);
//       return;
//     }

//     // Clean the URL so a page refresh doesn't re-trigger
//     const cleanUrl = window.location.pathname;
//     window.history.replaceState({}, '', cleanUrl);

//     // Try immediately (product cards may already be rendered)
//     if (this._tryAutoSelect(handle)) return;

//     // Cards may still be loading — watch for DOM changes
//     const observer = new MutationObserver(() => {
//       if (this._tryAutoSelect(handle)) {
//         observer.disconnect();
//       }
//     });
//     observer.observe(document.querySelector('.combo-content') || document.body, {
//       childList: true,
//       subtree: true
//     });

//     // Stop watching after 8 seconds regardless
//     setTimeout(() => observer.disconnect(), 8000);
//   }

//   _tryAutoSelect(handle) {
//     const btn = document.querySelector(`.js-atb-btn[data-handle="${handle}"]`);
//     if (!btn) return false;

//     // Scroll to the product card
//     btn.closest('.combo-card-wrapper')?.scrollIntoView({ behavior: 'smooth', block: 'center' });

//     // Brief highlight animation
//     const card = btn.closest('.combo-card-wrapper');
//     if (card) {
//       card.style.transition = 'box-shadow 0.4s ease';
//       card.style.boxShadow = '0 0 0 3px #543e3a';
//       setTimeout(() => { card.style.boxShadow = ''; }, 2000);
//     }

//     // Click the Add To Box button
//     setTimeout(() => btn.click(), 400);
//     return true;
//   }

//   bindAtbButtons(container) {
//     container.querySelectorAll('.js-atb-btn').forEach(btn => {
//       if (btn.dataset.comboBound === 'true') return;
//       btn.dataset.comboBound = 'true';
//       btn.addEventListener('click', (e) => this.handleAtbClick(e.currentTarget));
//     });
//   }

//   syncAddToBoxButtons(scope = document) {
//     scope.querySelectorAll('.js-atb-btn').forEach(btn => {
//       const isAdded = this.combo.some(item => item.variantId === btn.dataset.variantId);
//       btn.classList.toggle('is-added', isAdded);
//       btn.textContent = isAdded ? 'Added To Box' : 'Add To Box';
//     });
//   }

//   buildLoadMoreUrl(tier, nextPage, overrideParams = null) {
//     const collectionHandle = tier.dataset.collectionHandle;
//     const tagFilter = tier.dataset.tagFilter;

//     if (!collectionHandle) return '';

//     let path = `/collections/${collectionHandle}`;

//     if (tagFilter) {
//       path += `/${encodeURIComponent(tagFilter)}`;
//     }

//     let searchParams = '';
//     if (overrideParams !== null) {
//       // Use explicitly provided params (e.g. from a clear-filter link href)
//       searchParams = overrideParams;
//     } else {
//       // Read from the facet form inputs
//       const facetForm = tier.querySelector('aside.facets-wrapper facet-filters-form form');
//       if (facetForm) {
//         searchParams = new URLSearchParams(new FormData(facetForm)).toString();
//       }
//     }

//     const separator = searchParams ? '&' : '';
//     return `${path}?view=combo-products&page=${nextPage}${separator}${searchParams}`;
//   }

//   setupInfiniteScroll() {
//     const options = {
//       root: null,
//       rootMargin: '0px 0px 300px 0px', // Trigger 300px before sentinel enters viewport
//       threshold: 0
//     };

//     this.sentinelObserver = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (!entry.isIntersecting) return;
//         const sentinel = entry.target;
//         if (sentinel.dataset.allLoaded === 'true') return;
//         if (sentinel.dataset.loading === 'true') return;
//         this.loadMoreForSentinel(sentinel);
//       });
//     }, options);

//     document.querySelectorAll('.js-infinite-sentinel').forEach(sentinel => {
//       if (sentinel.dataset.allLoaded !== 'true') {
//         this.sentinelObserver.observe(sentinel);
//       }
//     });
//   }

//   async loadMoreForSentinel(sentinel, isReset = false) {
//     const tier = sentinel.closest('.js-combo-tier');
//     const grid = tier?.querySelector('.js-combo-grid');
//     const nextPage = isReset ? 1 : parseInt(sentinel.dataset.nextPage || '2', 10);

//     if (!tier || !grid) return;

//     sentinel.dataset.loading = 'true';
//     sentinel.classList.add('is-loading');

//     if (isReset) {
//       grid.classList.add('is-loading-grid');
//     }

//     const requestUrl = this.buildLoadMoreUrl(tier, nextPage, sentinel._clearParams ?? null);
//     delete sentinel._clearParams; // Clear after use so subsequent loads read from form
//     if (!requestUrl) {
//       sentinel.dataset.allLoaded = 'true';
//       this.sentinelObserver.unobserve(sentinel);
//       return;
//     }

//     try {
//       const response = await fetch(requestUrl, {
//         headers: { 'X-Requested-With': 'XMLHttpRequest' }
//       });

//       if (!response.ok) throw new Error('Failed to load more combo products.');

//       const html = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
//       const cards = doc.querySelectorAll('.combo-card-wrapper');
//       const meta = doc.querySelector('.combo-ajax-meta');
//       const facetsPayload = doc.getElementById('combo-facets-payload');

//       // Inject real filters from collection AJAX response (filters only available on collection URLs)
//       if (facetsPayload && isReset) {
//         const asideWrapper = tier.querySelector('aside.facets-wrapper');
//         if (asideWrapper) {
//           asideWrapper.innerHTML = facetsPayload.innerHTML;
//           this.setupFilterListeners();
//         }
//       }

//       if (cards.length) {
//         if (isReset) {
//           grid.innerHTML = '';
//           grid.classList.remove('is-loading-grid');
//         }
//         const fragment = document.createDocumentFragment();
//         cards.forEach(card => fragment.appendChild(card));
//         grid.appendChild(fragment);
//         this.bindAtbButtons(grid);
//         this.syncAddToBoxButtons(grid);
//       } else if (isReset) {
//         grid.innerHTML = '<p class="combo-no-results">No products found matching these filters.</p>';
//         grid.classList.remove('is-loading-grid');
//       }

//       const hasMore = meta?.dataset.hasMore === 'true' && cards.length > 0;
//       if (hasMore) {
//         sentinel.dataset.nextPage = String(nextPage + 1);
//         sentinel.dataset.loading = 'false';
//         sentinel.classList.remove('is-loading');
//         sentinel.dataset.allLoaded = 'false';
//         this.sentinelObserver.observe(sentinel);
//       } else {
//         sentinel.dataset.allLoaded = 'true';
//         sentinel.classList.remove('is-loading');
//         this.sentinelObserver.unobserve(sentinel);
//       }
//     } catch (error) {
//       console.error(error);
//       sentinel.dataset.loading = 'false';
//       sentinel.classList.remove('is-loading');
//       if (isReset) grid.classList.remove('is-loading-grid');
//     }
//   }

//   // Fetch filter HTML from the collection directly to get exact Swatches and Settings
//   async loadFiltersForTier(tier) {
//     const collectionHandle = tier.dataset.collectionHandle;
//     const blockId = tier.dataset.tierId || tier.id || Math.random().toString(36).substr(2, 9);
//     if (!collectionHandle) return;
//     const asideWrapper = tier.querySelector('aside.facets-wrapper');
//     if (!asideWrapper) return;

//     try {
//       // Fetch the raw collection page to get exact, fully-configured filter DOM with Swatches
//       const url = `/collections/${collectionHandle}`;
//       const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
//       if (!response.ok) return;
//       const html = await response.text();
//       const doc = new DOMParser().parseFromString(html, 'text/html');

//       const realAside = doc.querySelector('aside.facets-wrapper');
//       if (realAside) {
//         // Prevent ID collisions since we might load multiple tiers
//         let asideHtml = realAside.innerHTML;
//         asideHtml = asideHtml.replace(/FacetFiltersForm/g, 'FacetFiltersForm-' + blockId);
//         asideHtml = asideHtml.replace(/SortBy/g, 'SortBy-' + blockId);

//         asideWrapper.innerHTML = asideHtml;
//         this.setupFilterListeners();
//       }
//     } catch (e) {
//       console.warn('Could not load filters for tier:', collectionHandle, e);
//     }
//   }

//   setupFilterListeners() {
//     const self = this;
//     const filterDebounce = this.debounce((tier) => {
//       const sentinel = tier.querySelector('.js-infinite-sentinel');
//       if (sentinel) self.loadMoreForSentinel(sentinel, true);
//     }, 500);

//     document.querySelectorAll('.js-combo-tier').forEach(tier => {
//       // Target facet form inside the standard aside.facets-wrapper
//       const facetForm = tier.querySelector('aside.facets-wrapper facet-filters-form');
//       if (facetForm) {
//         facetForm.addEventListener('input', () => filterDebounce(tier));
//         const sortSelect = facetForm.querySelector('select[name="sort_by"]');
//         if (sortSelect) {
//           sortSelect.addEventListener('change', () => filterDebounce(tier));
//         }
//       }
//     });

//     // Handle facet-remove (× on active filter chip) and Clear all
//     document.addEventListener('click', (e) => {
//       const clearLink = e.target.closest('facet-remove a, a.active-facets__button--clear');
//       if (clearLink && clearLink.closest('.js-combo-tier')) {
//         e.preventDefault();
//         const tier = clearLink.closest('.js-combo-tier');
//         const sentinel = tier.querySelector('.js-infinite-sentinel');
//         if (!sentinel) return;

//         // Read the clean params from the clear link's own href
//         const href = clearLink.getAttribute('href') || '';
//         const hrefSearch = href.includes('?') ? href.split('?')[1] : '';
//         const cleanParams = new URLSearchParams(hrefSearch);
//         cleanParams.delete('view');
//         cleanParams.delete('page');

//         sentinel.dataset.nextPage = '1';
//         sentinel.dataset.allLoaded = 'false';
//         sentinel._clearParams = cleanParams.toString();
//         this.loadMoreForSentinel(sentinel, true);
//       }
//     });
//   }

//   debounce(fn, wait) {
//     let timeout;
//     return (...args) => {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }

//   getTierById(tierId) {
//     return document.querySelector(`.js-combo-tier[data-tier-id="${tierId}"]`);
//   }

//   getActiveTierElement() {
//     if (this.currentTierId) {
//       return this.getTierById(this.currentTierId);
//     }

//     return document.querySelector('.js-combo-tier.is-active') || document.querySelector('.js-combo-tier');
//   }

//   applyTierSettings(tier) {
//     if (!tier) return;

//     const maxSlots = parseInt(tier.dataset.maxSlots || '3', 10);
//     const minimumItems = parseInt(tier.dataset.minItems || '3', 10);
//     const discountPercentage = parseFloat(tier.dataset.discountPercentage || '20');
//     const tierPrice = parseInt(tier.dataset.tierPrice || '0', 10);

//     this.maxSlots = Number.isFinite(maxSlots) && maxSlots > 0 ? maxSlots : 3;
//     this.minimumItems = Number.isFinite(minimumItems) && minimumItems > 0
//       ? Math.min(minimumItems, this.maxSlots)
//       : Math.min(3, this.maxSlots);
//     this.discountPercentage = Number.isFinite(discountPercentage) && discountPercentage > 0 ? discountPercentage : 20;
//     this.tierPrice = Number.isFinite(tierPrice) ? tierPrice : 0;
//     this.discountCode = tier.dataset.discountCode || '';
//   }

//   handleTabClick(tab) {
//     if (tab.disabled) return;
//     const targetId = tab.dataset.target;

//     document.querySelectorAll('.js-tier-tab').forEach(t => t.classList.remove('is-active'));
//     tab.classList.add('is-active');

//     const targetTier = this.getTierById(targetId);
//     document.querySelectorAll('.js-combo-tier').forEach(tier => {
//       if (tier.dataset.tierId === targetId) {
//         tier.classList.add('is-active');
//       } else {
//         tier.classList.remove('is-active');
//       }
//     });

//     if (!this.currentTierId || this.currentTierId === targetId) {
//       this.applyTierSettings(targetTier);
//       this.updateUI();
//     }
//   }

//   async handleAtbClick(btn) {
//     const tier = btn.closest('.combo-tier');
//     const tierId = tier.dataset.tierId;
//     const variantId = btn.dataset.variantId;

//     if (this.currentTierId && this.currentTierId !== tierId) {
//       alert('Please complete or clear your current combo before switching tiers.');
//       return;
//     }

//     const productId = btn.dataset.productId;
//     const price = parseInt(btn.dataset.price, 10);
//     const image = btn.dataset.image;
//     const title = btn.dataset.title;

//     const index = this.combo.findIndex(item => item.variantId === variantId);

//     if (index > -1) {
//       const removedItem = this.combo[index];
//       this.combo.splice(index, 1);
//       btn.classList.remove('is-added');
//       btn.textContent = 'Add To Box';
//       if (this.combo.length === 0) this.currentTierId = null;
//       this.adjustGlobalCartCount(-1);
//       this.updateUI();

//       try {
//         const remRes = await fetch('/cart/change.json', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 0 })
//         });

//         if (!remRes.ok) {
//           throw new Error('Failed to remove combo item.');
//         }
//       } catch (error) {
//         console.error(error);
//         this.combo.splice(index, 0, removedItem);
//         this.currentTierId = tierId;
//         btn.classList.add('is-added');
//         btn.textContent = 'Added To Box';
//         this.adjustGlobalCartCount(1);
//         this.updateUI();
//         alert('Could not update the box. Please try again.');
//       }
//     } else {
//       this.applyTierSettings(tier);
//       const tierSlots = this.maxSlots;

//       if (this.combo.length < tierSlots) {
//         btn.disabled = true;
//         btn.textContent = 'Adding...';

//         try {
//           this.currentTierId = tierId;
//           this.combo.push({ productId, variantId, price, image, title });
//           btn.classList.add('is-added');
//           btn.textContent = 'Added To Box';
//           this.adjustGlobalCartCount(1);
//           this.updateUI();

//           const addRes = await fetch('/cart/add.json', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_combo': 'true' } }] })
//           });

//           if (!addRes.ok) {
//             throw new Error('Could not add item to cart.');
//           }
//         } catch (e) {
//           console.error(e);
//           this.combo = this.combo.filter(item => item.variantId !== variantId);
//           btn.classList.remove('is-added');
//           btn.textContent = 'Add To Box';
//           if (this.combo.length === 0) this.currentTierId = null;
//           this.adjustGlobalCartCount(-1);
//           this.updateUI();
//           alert('Could not add item to cart. Please try again.');
//         } finally {
//           btn.disabled = false;
//         }
//       } else {
//         alert(`You can only add up to ${tierSlots} items for this combo.`);
//       }
//     }
//   }

//   updateUI() {
//     if (!this.currentTierId) {
//       this.applyTierSettings(this.getActiveTierElement());
//     }

//     document.querySelectorAll('.combo-tier').forEach(tier => {
//       if (this.currentTierId && tier.dataset.tierId !== this.currentTierId) {
//         tier.classList.add('is-disabled');
//       } else {
//         tier.classList.remove('is-disabled');
//       }
//     });

//     document.querySelectorAll('.js-tier-tab').forEach(tab => {
//       if (this.currentTierId && tab.dataset.target !== this.currentTierId) {
//         tab.disabled = true;
//       } else {
//         tab.disabled = false;
//       }
//     });

//     this.syncAddToBoxButtons();

//     this.slotsContainer.innerHTML = '';
//     for (let i = 0; i < this.maxSlots; i++) {
//       const item = this.combo[i];
//       const slot = document.createElement('div');
//       slot.className = 'combo-slot' + (item ? '' : ' combo-slot--empty');

//       if (item) {
//         slot.innerHTML = `
//           <img src="${item.image}" alt="${item.title}">
//           <span class="combo-slot__remove" data-variant-id="${item.variantId}">×</span>
//         `;
//         slot.querySelector('.combo-slot__remove').addEventListener('click', (e) => {
//           this.removeItem(e.target.dataset.variantId);
//         });
//       } else {
//         slot.innerHTML = `<span class="add-piece">ADD<br>Item ${i + 1}</span>`;
//       }
//       this.slotsContainer.appendChild(slot);
//     }

//     const subtotal = this.combo.reduce((acc, item) => acc + item.price, 0);
//     const qualifiesForDiscount = this.combo.length >= this.minimumItems;
//     const discountAmount = qualifiesForDiscount
//       ? Math.round((subtotal * this.discountPercentage) / 100)
//       : 0;
//     const finalPriceToDisplay = subtotal - discountAmount;
//     const totalRow = document.querySelector('.js-total-row');

//     this.updateProgress(subtotal, qualifiesForDiscount);

//     if (qualifiesForDiscount) {
//       const formattedPrice = this.formatMoney(finalPriceToDisplay);
//       const formattedSubtotal = this.formatMoney(subtotal);
//       if (this.totalPriceEl) {
//         this.totalPriceEl.innerHTML = `${formattedPrice}<span class="combo-summary__compare">${formattedSubtotal}</span>`;
//       }
//       if (this.totalLabelEl) {
//         this.totalLabelEl.textContent = `Total (${this.discountPercentage}% OFF) -`;
//       }
//       if (totalRow) totalRow.style.display = 'flex';
//       this.checkoutBtn.disabled = false;
//       this.checkoutBtn.textContent = 'GO TO CART';

//       // Save discount state for cart popup banner
//       sessionStorage.setItem('comboDiscount', JSON.stringify({
//         subtotal,
//         discountAmount,
//         finalPrice: finalPriceToDisplay,
//         discountPercentage: this.discountPercentage
//       }));
//       this.injectComboDiscountBanner();
//     } else {
//       if (this.totalPriceEl) this.totalPriceEl.textContent = '---';
//       if (this.totalLabelEl) this.totalLabelEl.textContent = 'Total -';
//       if (totalRow) totalRow.style.display = 'none';
//       this.checkoutBtn.disabled = true;
//       this.checkoutBtn.textContent = this.buildDisabledCtaLabel();

//       // Clear discount state
//       sessionStorage.removeItem('comboDiscount');
//       this.injectComboDiscountBanner();
//     }
//   }

//   watchCartForComboDiscount() {
//     const self = this;

//     // Watch product list area – fires when generateCart() re-renders items
//     const cartContent = document.querySelector('.js-mini-cart-content');
//     if (cartContent) {
//       new MutationObserver(() => {
//         requestAnimationFrame(() => self.injectComboDiscountBanner());
//       }).observe(cartContent, { childList: true });
//     }

//     // Watch cart total text – fires when updateElements() refreshes the price
//     const cartTotalEl = document.querySelector('.js-cart-total');
//     if (cartTotalEl) {
//       new MutationObserver(() => {
//         requestAnimationFrame(() => self.injectComboDiscountBanner());
//       }).observe(cartTotalEl, { childList: true, subtree: true, characterData: true });
//     }
//   }

//   injectComboDiscountBanner() {
//     // Remove any stale banner first
//     document.querySelectorAll('.combo-cart-discount-banner').forEach(el => el.remove());

//     const raw = sessionStorage.getItem('comboDiscount');
//     if (!raw) return;

//     const { subtotal, discountAmount, finalPrice, discountPercentage } = JSON.parse(raw);

//     const bottomTotal = document.querySelector('.bottom-total');
//     if (!bottomTotal) return;

//     // Override the Shopify-rendered total with discounted price
//     const cartTotalEl = document.querySelector('.js-cart-total');
//     if (cartTotalEl && !cartTotalEl.dataset.comboOverridden) {
//       cartTotalEl.dataset.comboOverridden = 'true';
//       cartTotalEl.innerHTML = this.formatMoney(finalPrice);
//       setTimeout(() => { delete cartTotalEl.dataset.comboOverridden; }, 100);
//     }

//     // Build and inject the banner above the total row
//     const banner = document.createElement('div');
//     banner.className = 'combo-cart-discount-banner';
//     banner.innerHTML = `
//       <div class="combo-cart-discount-row">
//         <span class="combo-cart-badge">🎁 COMBO ${discountPercentage}% OFF</span>
//         <span class="combo-cart-saving">You save ${this.formatMoney(discountAmount)}</span>
//       </div>
//       <div class="combo-cart-original">
//         Original: <s>${this.formatMoney(subtotal)}</s> → <strong>${this.formatMoney(finalPrice)}</strong>
//       </div>
//     `;
//     bottomTotal.parentNode.insertBefore(banner, bottomTotal);
//   }

//   updateProgress(subtotal, qualifiesForDiscount) {
//     document.querySelectorAll('.combo-progress-wrapper').forEach(wrapper => {
//       const fill = wrapper.querySelector('.combo-progress-fill');
//       const text = wrapper.querySelector('.combo-progress-text');

//       if (fill) {
//         fill.style.width = '0%';
//         fill.style.background = '#228be6';
//       }

//       if (text) {
//         text.textContent = `Add ${this.minimumItems} items to unlock ${this.discountPercentage}% OFF.`;
//       }
//     });

//     const activeTier = this.getActiveTierElement();
//     if (!activeTier) return;

//     const progressText = activeTier.querySelector('.combo-progress-text');
//     const progressFill = activeTier.querySelector('.combo-progress-fill');
//     if (!progressText || !progressFill) return;

//     const progressTarget = Math.max(this.minimumItems, 1);
//     const percent = Math.min((this.combo.length / progressTarget) * 100, 100);
//     progressFill.style.width = `${percent}%`;

//     if (qualifiesForDiscount) {
//       const remainingSlots = Math.max(this.maxSlots - this.combo.length, 0);
//       const extraCopy = remainingSlots > 0
//         ? ` Add ${remainingSlots} more item${remainingSlots === 1 ? '' : 's'} and keep the discount.`
//         : '';
//       progressText.textContent = `${this.discountPercentage}% OFF unlocked on ${this.formatMoney(subtotal)}.${extraCopy}`;
//       progressFill.style.background = '#00b84c';
//       return;
//     }

//     const remainingToUnlock = Math.max(this.minimumItems - this.combo.length, 0);
//     progressText.textContent = `Add ${remainingToUnlock} more item${remainingToUnlock === 1 ? '' : 's'} to unlock ${this.discountPercentage}% OFF.`;
//   }

//   buildDisabledCtaLabel() {
//     const remaining = Math.max(this.minimumItems - this.combo.length, 0);

//     if (remaining <= 0) {
//       return 'GO TO CART';
//     }

//     if (this.combo.length === 0) {
//       return `ADD ${this.minimumItems} ITEMS`;
//     }

//     return `ADD ${remaining} MORE`;
//   }

//   async removeItem(variantId) {
//     const index = this.combo.findIndex(item => item.variantId === variantId);
//     if (index > -1) {
//       const [removedItem] = this.combo.splice(index, 1);
//       const btn = document.querySelector(`.js-atb-btn[data-variant-id="${variantId}"]`);
//       if (btn) {
//         btn.classList.remove('is-added');
//         btn.textContent = 'Add To Box';
//       }
//       if (this.combo.length === 0) this.currentTierId = null;
//       this.adjustGlobalCartCount(-1);
//       this.updateUI();

//       try {
//         const remRes = await fetch('/cart/change.json', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 0 })
//         });

//         if (!remRes.ok) {
//           throw new Error('Failed to remove combo item.');
//         }
//       } catch (error) {
//         console.error(error);
//         this.combo.splice(index, 0, removedItem);
//         if (btn) {
//           btn.classList.add('is-added');
//           btn.textContent = 'Added To Box';
//         }
//         if (!this.currentTierId) {
//           this.currentTierId = this.getActiveTierElement()?.dataset.tierId || null;
//         }
//         this.adjustGlobalCartCount(1);
//         this.updateUI();
//         alert('Could not update the box. Please try again.');
//       }
//     }
//   }

//   setGlobalCartCount(itemCount) {
//     document.querySelectorAll('.js-cart-count').forEach(el => {
//       el.textContent = itemCount;
//       el.classList.toggle('hide', itemCount <= 0);
//     });
//   }

//   adjustGlobalCartCount(delta) {
//     const currentCountEl = document.querySelector('.js-cart-count');
//     const currentCount = currentCountEl ? parseInt(currentCountEl.textContent || '0', 10) : 0;
//     const nextCount = Math.max((Number.isFinite(currentCount) ? currentCount : 0) + delta, 0);
//     this.setGlobalCartCount(nextCount);
//   }

//   async updateGlobalCartCount() {
//     try {
//       const res = await fetch('/cart.js');
//       const cart = await res.json();
//       this.setGlobalCartCount(cart.item_count);
//     } catch (e) {
//       console.error('Failed to update cart count', e);
//     }
//   }

//   formatMoney(cents) {
//     return '₹' + (cents / 100).toLocaleString('en-IN', {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 2
//     });
//   }

//   async handleCheckout() {
//     if (this.combo.length < this.minimumItems) return;

//     this.isCheckingOut = true;
//     this.checkoutBtn.disabled = true;
//     this.checkoutBtn.textContent = 'OPENING CART...';

//     if (window.theme && theme.miniCart) {
//       theme.miniCart.generateCart();
//       theme.miniCart.updateElements();
//       const miniCartEl = document.querySelector('.js-mini-cart');
//       if (miniCartEl) {
//         miniCartEl.classList.add('active');
//         document.querySelector('.mini-cart-content').parentElement.classList.add('active');
//       } else {
//         window.location.href = '/cart';
//       }
//     } else {
//       const cartIcon = document.querySelector('.js-toggle-cart, .site-header__cart, .header__icon--cart, a[href="/cart"]');
//       if (cartIcon) {
//         cartIcon.click();
//       } else {
//         window.location.href = '/cart';
//       }
//     }

//     setTimeout(() => {
//       this.isCheckingOut = false;
//       this.checkoutBtn.disabled = false;
//       this.checkoutBtn.textContent = 'GO TO CART';
//     }, 1500);
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   window.comboPage = new ComboPage();
// });


class ComboPage {
  constructor() {
    this.nativeUtsavCollection = Boolean(document.querySelector('[data-kp-native-utsav-collection]'));
    document.body.classList.add('combo-page-active');
    this.combo = [];
    this.maxSlots = 3;
    this.minimumItems = 3;
    this.discountPercentage = 20;
    this.tierPrice = 0;
    this.currentTierId = null;
    this.discountCode = '';
    this.footer = document.querySelector('.combo-footer');
    this.checkoutBtn = document.querySelector('.combo-checkout-btn');
    this.totalPriceEl = document.querySelector('.js-combo-total');
    this.totalLabelEl = document.querySelector('.js-combo-total-label');
    this.totalCompareEl = document.querySelector('.js-combo-total-compare');
    this.totalSavingEl = document.querySelector('.js-combo-total-saving');
    this.summaryCountEl = document.querySelector('.js-combo-summary-count');
    this.summaryMessageEl = document.querySelector('.js-combo-summary-message');
    this.slotsContainer = document.querySelector('.combo-slots');
    this.productDialog = document.querySelector('[data-combo-product-dialog]');
    this.confirmDialog = document.querySelector('[data-combo-confirm-dialog]');
    this.celebration = document.querySelector('[data-combo-celebration]');
    this.celebrationAmount = document.querySelector('[data-combo-celebration-amount]');
    this.confettiContainer = document.querySelector('[data-combo-confetti]');
    this.celebrationTimer = null;
    this.savingsAnimationFrame = null;
    this.activeCuratedCategory = 'all';
    this.isCheckingOut = false;
    this.mobileViewportQuery = window.matchMedia('(max-width: 768px)');
    if (!this.nativeUtsavCollection) {
      this.mobileViewportQuery.addEventListener('change', () => this.updateUI());
    }
    this.init();
  }

  async init() {
    if (this.nativeUtsavCollection) {
      this.bindProductCardEnhancements(document);
      return;
    }
    // 1. Fetch current cart and sync combo state (Replacing the cart clear logic to prevent replacement)
    await this.syncWithCart();

    this.bindAtbButtons(document);
    this.bindSuggestedComboButtons();
    this.bindCuratedCategoryButtons();
    this.bindProductCardEnhancements(document);
    this.bindOverlayControls();

    this.setupInfiniteScroll();
    this.hasFacetControls = Boolean(document.querySelector('.js-combo-tier .facets-wrapper'));
    if (this.hasFacetControls) {
      this.setupFilterListeners();
    }

    if (this.breadcrumbFiltersEnabled()) {
      this.setupBreadcrumbFilters();
    } else {
      sessionStorage.removeItem('combo_last_filter');
    }

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCheckout();
      });
    }

    document.querySelectorAll('.js-tier-tab').forEach(btn => {
      btn.addEventListener('click', (e) => this.handleTabClick(e.currentTarget));
    });

    this.applyTierSettings(this.getActiveTierElement());

    if (this.breadcrumbFiltersEnabled()) {
      this.restoreLastFilter();
    }

    this.updateUI();
    this.watchCartForComboDiscount();

    // Load real filters from collection URL for each tier (filters only available on collection pages)
    if (this.hasFacetControls) {
      document.querySelectorAll('.js-combo-tier').forEach(tier => this.loadFiltersForTier(tier));
    }

    // Auto-select a product if redirected from PDP via ?autoselect=handle
    this.handleAutoSelect();
  }

  async syncWithCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.setGlobalCartCount(cart.item_count);

      // Filter items that belong to the combo
      this.combo = cart.items
        .filter(item => item.properties && item.properties._combo === 'true')
        .map(item => ({
          productId: String(item.product_id),
          variantId: String(item.variant_id),
          price: item.price,
          image: item.image,
          title: item.product_title,
          handle: item.handle,
          tierId: item.properties._tier_id
        }));

      // Try to identify the tier from the first item found to lock it
      if (this.combo.length > 0) {
        const firstId = this.combo[0].variantId;
        const btn = document.querySelector(`.js-atb-btn[data-variant-id="${firstId}"]`);
        if (btn) {
          const tier = btn.closest('.combo-tier');
          if (tier) this.currentTierId = tier.dataset.tierId;
        }
      }
    } catch (e) {
      console.error('Failed to sync with cart', e);
    }
  }

  // --- NEW INTEGRATED FILTER METHODS ---
  breadcrumbFiltersEnabled() {
    const comboPage = document.querySelector('.combo-page');
    return comboPage?.dataset.enableBreadcrumbFilters === 'true';
  }

  setupBreadcrumbFilters() {
    const breadcrumbs = document.querySelectorAll('.js-breadcrumb-container a[data-handle]');
    breadcrumbs.forEach(link => {
      link.addEventListener('click', async (e) => {
        e.preventDefault();
        const handle = link.dataset.handle;
        this.applyFilter(handle);
      });
    });
  }

  async applyFilter(handle) {
    const activeTier = this.getActiveTierElement();
    if (!activeTier || !handle) return;
    sessionStorage.setItem('combo_last_filter', handle);

    const breadcrumbs = document.querySelectorAll('.js-breadcrumb-container a[data-handle]');
    breadcrumbs.forEach(b => {
      b.style.fontWeight = (b.dataset.handle === handle) ? '700' : '400';
      b.style.textDecoration = (b.dataset.handle === handle) ? 'underline' : 'none';
    });

    const sentinel = activeTier.querySelector('.js-infinite-sentinel');
    const grid = activeTier.querySelector('.js-combo-grid');
    if (!sentinel || !grid) return;

    grid.style.opacity = '0.5';
    grid.classList.add('is-loading-grid');
    activeTier.dataset.collectionHandle = handle;
    sentinel.dataset.nextPage = '1';
    sentinel.dataset.allLoaded = 'false';
    sentinel._isBreadcrumbFilter = true;

    await this.loadMoreForSentinel(sentinel, true);
    
    sentinel._isBreadcrumbFilter = false;
    grid.style.opacity = '1';
    grid.classList.remove('is-loading-grid');
    if (this.sentinelObserver) this.sentinelObserver.observe(sentinel);
  }

  restoreLastFilter() {
    const lastFilter = sessionStorage.getItem('combo_last_filter');
    if (lastFilter) this.applyFilter(lastFilter);
  }
  // --- END FILTER METHODS ---

  handleAutoSelect() {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('autoselect') || sessionStorage.getItem('kpComboAutoSelect');
    if (!handle) return;

    sessionStorage.removeItem('kpComboAutoSelect');

    // If already in combo, don't trigger another click (which would remove it)
    if (this.combo.some(item => item.handle === handle)) {
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      return;
    }

    // Clean the URL so a page refresh doesn't re-trigger
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);

    // Try immediately (product cards may already be rendered)
    if (this._tryAutoSelect(handle)) return;

    // Cards may still be loading — watch for DOM changes
    const observer = new MutationObserver(() => {
      if (this._tryAutoSelect(handle)) {
        observer.disconnect();
      }
    });
    observer.observe(document.querySelector('.combo-content') || document.body, {
      childList: true,
      subtree: true
    });

    // Stop watching after 8 seconds regardless
    setTimeout(() => observer.disconnect(), 8000);
  }

  _tryAutoSelect(handle) {
    const btn = document.querySelector(`.js-atb-btn[data-handle="${handle}"]`);
    if (!btn) return false;

    // Scroll to the product card
    btn.closest('.combo-card-wrapper')?.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Brief highlight animation
    const card = btn.closest('.combo-card-wrapper');
    if (card) {
      card.style.transition = 'box-shadow 0.4s ease';
      card.style.boxShadow = '0 0 0 3px #543e3a';
      setTimeout(() => { card.style.boxShadow = ''; }, 2000);
    }

    // Click the Add To Box button
    setTimeout(() => btn.click(), 400);
    return true;
  }

  bindAtbButtons(container) {
    container.querySelectorAll('.js-atb-btn').forEach(btn => {
      if (btn.dataset.comboBound === 'true') return;
      btn.dataset.comboBound = 'true';
      btn.addEventListener('click', (e) => this.handleAtbClick(e.currentTarget));
    });
  }

  bindSuggestedComboButtons() {
    document.querySelectorAll('[data-combo-suggestion]').forEach(button => {
      if (button.dataset.comboSuggestionBound === 'true') return;
      button.dataset.comboSuggestionBound = 'true';
      button.addEventListener('click', () => this.applySuggestedCombo(button));
    });
  }

  async applySuggestedCombo(button) {
    const handles = (button.dataset.comboHandles || '')
      .split(',')
      .map(handle => handle.trim())
      .filter(Boolean);

    if (!handles.length) return;

    button.disabled = true;
    try {
      for (const item of [...this.combo]) {
        await this.removeItem(item.variantId);
      }

      for (const handle of handles) {
        const addButton = document.querySelector(`.js-atb-btn[data-handle="${handle}"]`);
        if (addButton && !addButton.classList.contains('is-added')) {
          await this.handleAtbClick(addButton);
        }
      }
    } finally {
      button.disabled = false;
    }
  }

  bindCuratedCategoryButtons() {
    document.querySelectorAll('.combo-curated-category').forEach(button => {
      if (button.dataset.comboCategoryBound === 'true') return;
      button.dataset.comboCategoryBound = 'true';
      button.addEventListener('click', () => {
        const category = button.dataset.comboCategory || 'all';
        this.activeCuratedCategory = category;
        document.querySelectorAll('.combo-curated-category').forEach(categoryButton => {
          categoryButton.classList.toggle('is-active', categoryButton === button);
        });
        this.filterCuratedCategory(category);
      });
    });
  }

  bindProductCardEnhancements(container) {
    container.querySelectorAll('[data-combo-card-gallery]').forEach(gallery => {
      if (gallery.dataset.comboGalleryBound === 'true') return;
      gallery.dataset.comboGalleryBound = 'true';

      const card = gallery.closest('.combo-card-wrapper');
      const track = gallery.querySelector('[data-combo-gallery-track]');
      const previousButton = gallery.querySelector('[data-combo-gallery-previous]');
      const nextButton = gallery.querySelector('[data-combo-gallery-next]');
      let pointerStartScroll = 0;

      const openDetails = trigger => this.openProductDialog(card, trigger);
      const syncNavigation = () => this.syncMediaNavigation(track, previousButton, nextButton);

      if (track) {
        track.addEventListener('pointerdown', () => {
          pointerStartScroll = track.scrollLeft;
        });
        track.addEventListener('click', event => {
          if (Math.abs(track.scrollLeft - pointerStartScroll) > 6) return;
          event.preventDefault();
          openDetails(track);
        });
        track.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openDetails(track);
        });
        track.addEventListener('scroll', () => {
          syncNavigation();
        }, { passive: true });

        previousButton?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.moveMedia(track, -1, previousButton, nextButton);
        });
        nextButton?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.moveMedia(track, 1, previousButton, nextButton);
        });
        syncNavigation();
      }

      card?.querySelectorAll('.luxury-title, .product-card__name').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          openDetails(link);
        });
      });
    });
  }

  bindOverlayControls() {
    if (this.productDialog) {
      this.productDialog.querySelectorAll('[data-combo-product-close]').forEach(button => {
        button.addEventListener('click', () => this.closeOverlay(this.productDialog));
      });
      const dialogMedia = this.productDialog.querySelector('[data-combo-product-dialog-media]');
      const previousMediaButton = this.productDialog.querySelector('[data-combo-product-media-previous]');
      const nextMediaButton = this.productDialog.querySelector('[data-combo-product-media-next]');
      const syncDialogNavigation = () => this.syncMediaNavigation(dialogMedia, previousMediaButton, nextMediaButton);

      dialogMedia?.addEventListener('scroll', syncDialogNavigation, { passive: true });
      previousMediaButton?.addEventListener('click', event => {
        event.preventDefault();
        this.moveMedia(dialogMedia, -1, previousMediaButton, nextMediaButton);
      });
      nextMediaButton?.addEventListener('click', event => {
        event.preventDefault();
        this.moveMedia(dialogMedia, 1, previousMediaButton, nextMediaButton);
      });
      this.productDialog.querySelector('[data-combo-product-dialog-link]')?.addEventListener('click', event => {
        const destination = event.currentTarget.dataset.productUrl;
        if (!destination) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        window.location.assign(destination);
      });
      this.productDialog.querySelector('[data-combo-product-dialog-add]')?.addEventListener('click', async event => {
        const modalButton = event.currentTarget;
        const handle = this.productDialog.dataset.productHandle;
        const sourceButton = Array.from(document.querySelectorAll('.js-atb-btn'))
          .find(button => button.dataset.handle === handle);
        if (!sourceButton) return;

        modalButton.disabled = true;
        await this.handleAtbClick(sourceButton);
        modalButton.disabled = false;
        modalButton.textContent = sourceButton.classList.contains('is-added')
          ? 'Added to combo'
          : 'Add to combo';
        setTimeout(() => this.closeOverlay(this.productDialog), 350);
      });
    }

    if (this.confirmDialog) {
      this.confirmDialog.querySelectorAll('[data-combo-confirm-close]').forEach(button => {
        button.addEventListener('click', () => this.closeOverlay(this.confirmDialog));
      });
      this.confirmDialog.querySelector('[data-combo-confirm-submit]')?.addEventListener('click', () => {
        this.completeCheckout();
      });
    }

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      if (this.productDialog && !this.productDialog.hidden) this.closeOverlay(this.productDialog);
      if (this.confirmDialog && !this.confirmDialog.hidden) this.closeOverlay(this.confirmDialog);
    });
  }

  openProductDialog(card, trigger) {
    if (this.nativeUtsavCollection) {
      try {
        const url = new URL(card?.dataset.comboProductUrl || '', window.location.origin);
        if (url.origin === window.location.origin && url.pathname.startsWith('/products/')) {
          window.location.assign(window.KpUtsavJourney?.productUrl?.(url.href) || url.href);
        }
      } catch (_) {}
      return;
    }
    if (!card || !this.productDialog) return;
    this.lastDialogTrigger = trigger;
    this.productDialog.dataset.productHandle = card.dataset.comboProductHandle || '';

    const title = this.productDialog.querySelector('[data-combo-product-dialog-title]');
    const price = this.productDialog.querySelector('[data-combo-product-dialog-price]');
    const merchLabel = this.productDialog.querySelector('[data-combo-product-dialog-merch]');
    const selectionCount = this.productDialog.querySelector('[data-combo-product-dialog-selection]');
    const specifications = this.productDialog.querySelector('[data-combo-product-dialog-specifications]');
    const media = this.productDialog.querySelector('[data-combo-product-dialog-media]');
    const previousMediaButton = this.productDialog.querySelector('[data-combo-product-media-previous]');
    const nextMediaButton = this.productDialog.querySelector('[data-combo-product-media-next]');
    const link = this.productDialog.querySelector('[data-combo-product-dialog-link]');
    const addButton = this.productDialog.querySelector('[data-combo-product-dialog-add]');
    const sourceButton = card.querySelector('.js-atb-btn');

    if (title) title.textContent = card.dataset.comboProductTitle || '';
    if (price) price.textContent = card.dataset.comboProductPrice || '';
    if (merchLabel) {
      merchLabel.textContent = card.dataset.comboMerchLabel || 'Easy to combine';
    }
    if (selectionCount) {
      const weeklySelections = Number.parseInt(card.dataset.comboSelectionCount || '', 10);
      if (Number.isFinite(weeklySelections) && weeklySelections > 0) {
        selectionCount.textContent = `${weeklySelections.toLocaleString('en-IN')} times selected in combos this week`;
        selectionCount.hidden = false;
      } else {
        selectionCount.textContent = '';
        selectionCount.hidden = true;
      }
    }
    if (specifications) {
      const specificationTemplate = card.querySelector('[data-combo-product-specifications]');
      specifications.replaceChildren();
      if (specificationTemplate?.content) {
        specifications.appendChild(specificationTemplate.content.cloneNode(true));
      }
      specifications.scrollTop = 0;
    }
    if (link) {
      const productUrl = card.dataset.comboProductUrl;
      const destination = productUrl ? new URL(productUrl, window.location.origin).href : '';
      link.href = destination || '#';
      link.dataset.productUrl = destination;
      link.setAttribute('aria-disabled', destination ? 'false' : 'true');
    }
    if (addButton) {
      addButton.textContent = sourceButton?.classList.contains('is-added') ? 'Remove from combo' : 'Add to combo';
    }

    if (media) {
      media.innerHTML = '';
      card.querySelectorAll('.combo-card-gallery__track img').forEach((sourceImage, index) => {
        const image = sourceImage.cloneNode();
        image.loading = index === 0 ? 'eager' : 'lazy';
        media.appendChild(image);
      });
      media.scrollLeft = 0;
      requestAnimationFrame(() => this.syncMediaNavigation(media, previousMediaButton, nextMediaButton));
    }

    this.openOverlay(this.productDialog);
  }

  moveMedia(media, direction, previousButton, nextButton) {
    if (!media || !media.clientWidth) return;
    const itemCount = media.children.length;
    if (itemCount < 2) return;
    const currentIndex = Math.round(media.scrollLeft / media.clientWidth);
    const nextIndex = Math.max(0, Math.min(itemCount - 1, currentIndex + direction));
    media.scrollLeft = nextIndex * media.clientWidth;
    this.syncMediaNavigation(media, previousButton, nextButton);
  }

  syncMediaNavigation(media, previousButton, nextButton) {
    if (!media) return;
    const itemCount = media.children.length;
    const hasMultipleImages = itemCount > 1;
    const activeIndex = media.clientWidth
      ? Math.round(media.scrollLeft / media.clientWidth)
      : 0;

    if (previousButton) {
      previousButton.hidden = !hasMultipleImages;
      previousButton.disabled = activeIndex <= 0;
    }
    if (nextButton) {
      nextButton.hidden = !hasMultipleImages;
      nextButton.disabled = activeIndex >= itemCount - 1;
    }
  }

  openConfirmDialog() {
    if (!this.confirmDialog || this.combo.length < this.minimumItems) return;

    const items = this.confirmDialog.querySelector('[data-combo-confirm-items]');
    const saving = this.confirmDialog.querySelector('[data-combo-confirm-saving]');
    const total = this.confirmDialog.querySelector('[data-combo-confirm-total]');
    const subtotal = this.combo.reduce((sum, item) => sum + item.price, 0);
    const discountAmount = Math.round((subtotal * this.discountPercentage) / 100);

    if (items) {
      items.innerHTML = '';
      this.combo.forEach(item => {
        const row = document.createElement('div');
        row.className = 'combo-confirm-item';

        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.width = 48;
        image.height = 48;

        const copy = document.createElement('div');
        const name = document.createElement('strong');
        const price = document.createElement('span');
        name.textContent = item.title;
        price.textContent = this.formatMoney(item.price);
        copy.append(name, price);
        row.append(image, copy);
        items.appendChild(row);
      });
    }

    if (saving) {
      saving.textContent = `${this.discountPercentage}% unlocked · You save ${this.formatMoney(discountAmount)}`;
    }
    if (total) total.textContent = this.formatMoney(subtotal - discountAmount);
    this.openOverlay(this.confirmDialog);
  }

  openOverlay(overlay) {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('combo-overlay-open');
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    overlay.querySelector('.combo-overlay__close')?.focus({ preventScroll: true });
  }

  closeOverlay(overlay) {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    setTimeout(() => {
      overlay.hidden = true;
      if (![this.productDialog, this.confirmDialog].some(item => item && !item.hidden)) {
        document.body.classList.remove('combo-overlay-open');
      }
      this.lastDialogTrigger?.focus?.({ preventScroll: true });
    }, 180);
  }

  filterCuratedCategory(category = 'all') {
    document.querySelectorAll('.combo-card-wrapper').forEach(card => {
      const isVisible = category === 'all' || card.dataset.comboCategory === category;
      card.hidden = !isVisible;
    });
  }

  syncAddToBoxButtons(scope = document) {
    scope.querySelectorAll('.js-atb-btn').forEach(btn => {
      const tier = btn.closest('.combo-tier');
      const tierId = tier ? tier.dataset.tierId : null;
      const isAdded = this.combo.some(item => item.variantId === btn.dataset.variantId && (item.tierId === tierId || !tierId));
      btn.classList.toggle('is-added', isAdded);
      btn.textContent = isAdded ? 'Added To Box' : 'Add To Box';
    });
  }

  buildLoadMoreUrl(tier, nextPage, overrideParams = null) {
    const collectionHandle = tier.dataset.collectionHandle;
    const sentinel = tier.querySelector('.js-infinite-sentinel');
    const isBreadcrumbFilter = sentinel && sentinel._isBreadcrumbFilter === true;
    const tagFilter = isBreadcrumbFilter ? '' : tier.dataset.tagFilter;

    if (!collectionHandle) return '';

    let path = `/collections/${collectionHandle}`;

    if (tagFilter) {
      path += `/${encodeURIComponent(tagFilter)}`;
    }

    let searchParams = '';
    if (overrideParams !== null) {
      // Use explicitly provided params (e.g. from a clear-filter link href)
      searchParams = overrideParams;
    } else if (!isBreadcrumbFilter) {
      // Read from the facet form inputs
      const facetForm = tier.querySelector('aside.facets-wrapper facet-filters-form form');
      if (facetForm) {
        searchParams = new URLSearchParams(new FormData(facetForm)).toString();
      }
    }

    const separator = searchParams ? '&' : '';
    return `${path}?view=combo-products&page=${nextPage}${separator}${searchParams}`;
  }

  setupInfiniteScroll() {
    const options = {
      root: null,
      rootMargin: '0px 0px 300px 0px', // Trigger 300px before sentinel enters viewport
      threshold: 0
    };

    this.sentinelObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const sentinel = entry.target;
        if (sentinel.dataset.allLoaded === 'true') return;
        if (sentinel.dataset.loading === 'true') return;
        this.loadMoreForSentinel(sentinel);
      });
    }, options);

    document.querySelectorAll('.js-infinite-sentinel').forEach(sentinel => {
      if (sentinel.dataset.allLoaded !== 'true') {
        this.sentinelObserver.observe(sentinel);
      }
    });
  }

  async loadMoreForSentinel(sentinel, isReset = false) {
    const tier = sentinel.closest('.js-combo-tier');
    const grid = tier?.querySelector('.js-combo-grid');
    const nextPage = isReset ? 1 : parseInt(sentinel.dataset.nextPage || '2', 10);

    if (!tier || !grid) return;

    sentinel.dataset.loading = 'true';
    sentinel.classList.add('is-loading');

    if (isReset) {
      grid.classList.add('is-loading-grid');
    }

    const requestUrl = this.buildLoadMoreUrl(tier, nextPage, sentinel._clearParams ?? null);
    delete sentinel._clearParams; // Clear after use so subsequent loads read from form
    if (!requestUrl) {
      sentinel.dataset.allLoaded = 'true';
      this.sentinelObserver.unobserve(sentinel);
      return;
    }

    try {
      const response = await fetch(requestUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Failed to load more combo products.');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('.combo-card-wrapper');
      const meta = doc.querySelector('.combo-ajax-meta');
      const facetsPayload = doc.getElementById('combo-facets-payload');

      // Inject real filters from collection AJAX response (filters only available on collection URLs)
      if (facetsPayload && isReset) {
        const asideWrapper = tier.querySelector('aside.facets-wrapper');
        if (asideWrapper) {
          asideWrapper.innerHTML = facetsPayload.innerHTML;
          this.setupFilterListeners();
        }
      }

      if (cards.length) {
        if (isReset) {
          grid.innerHTML = '';
          grid.classList.remove('is-loading-grid');
        }
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.appendChild(card));
        grid.appendChild(fragment);
        this.bindAtbButtons(grid);
        this.bindProductCardEnhancements(grid);
        this.syncAddToBoxButtons(grid);
      } else if (isReset) {
        grid.innerHTML = '<p class="combo-no-results">No products found matching these filters.</p>';
        grid.classList.remove('is-loading-grid');
      }

      this.filterCuratedCategory(this.activeCuratedCategory);

      const hasMore = meta?.dataset.hasMore === 'true' && cards.length > 0;
      if (hasMore) {
        sentinel.dataset.nextPage = String(nextPage + 1);
        sentinel.dataset.loading = 'false';
        sentinel.classList.remove('is-loading');
        sentinel.dataset.allLoaded = 'false';
        this.sentinelObserver.observe(sentinel);
      } else {
        sentinel.dataset.allLoaded = 'true';
        sentinel.classList.remove('is-loading');
        this.sentinelObserver.unobserve(sentinel);
      }
    } catch (error) {
      console.error(error);
      sentinel.dataset.loading = 'false';
      sentinel.classList.remove('is-loading');
      if (isReset) grid.classList.remove('is-loading-grid');
    }
  }

  // Fetch filter HTML from the collection directly to get exact Swatches and Settings
  async loadFiltersForTier(tier) {
    const collectionHandle = tier.dataset.collectionHandle;
    const blockId = tier.dataset.tierId || tier.id || Math.random().toString(36).substr(2, 9);
    if (!collectionHandle) return;
    const asideWrapper = tier.querySelector('aside.facets-wrapper');
    if (!asideWrapper) return;

    try {
      // Fetch the raw collection page to get exact, fully-configured filter DOM with Swatches
      const url = `/collections/${collectionHandle}`;
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const realAside = doc.querySelector('aside.facets-wrapper');
      if (realAside) {
        // Prevent ID collisions since we might load multiple tiers
        let asideHtml = realAside.innerHTML;
        asideHtml = asideHtml.replace(/FacetFiltersForm/g, 'FacetFiltersForm-' + blockId);
        asideHtml = asideHtml.replace(/SortBy/g, 'SortBy-' + blockId);

        asideWrapper.innerHTML = asideHtml;
        this.setupFilterListeners();
      }
    } catch (e) {
      console.warn('Could not load filters for tier:', collectionHandle, e);
    }
  }

  setupFilterListeners() {
    const self = this;
    const filterDebounce = this.debounce((tier) => {
      const sentinel = tier.querySelector('.js-infinite-sentinel');
      if (sentinel) self.loadMoreForSentinel(sentinel, true);
    }, 500);

    document.querySelectorAll('.js-combo-tier').forEach(tier => {
      // Target facet form inside the standard aside.facets-wrapper
      const facetForm = tier.querySelector('aside.facets-wrapper facet-filters-form');
      if (facetForm) {
        facetForm.addEventListener('input', () => filterDebounce(tier));
        const sortSelect = facetForm.querySelector('select[name="sort_by"]');
        if (sortSelect) {
          sortSelect.addEventListener('change', () => filterDebounce(tier));
        }
      }
    });

    // Handle facet-remove (× on active filter chip) and Clear all
    document.addEventListener('click', (e) => {
      const clearLink = e.target.closest('facet-remove a, a.active-facets__button--clear');
      if (clearLink && clearLink.closest('.js-combo-tier')) {
        e.preventDefault();
        const tier = clearLink.closest('.js-combo-tier');
        const sentinel = tier.querySelector('.js-infinite-sentinel');
        if (!sentinel) return;

        // Read the clean params from the clear link's own href
        const href = clearLink.getAttribute('href') || '';
        const hrefSearch = href.includes('?') ? href.split('?')[1] : '';
        const cleanParams = new URLSearchParams(hrefSearch);
        cleanParams.delete('view');
        cleanParams.delete('page');

        sentinel.dataset.nextPage = '1';
        sentinel.dataset.allLoaded = 'false';
        sentinel._clearParams = cleanParams.toString();
        this.loadMoreForSentinel(sentinel, true);
      }
    });
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  getTierById(tierId) {
    return document.querySelector(`.js-combo-tier[data-tier-id="${tierId}"]`);
  }

  getActiveTierElement() {
    if (this.currentTierId) {
      return this.getTierById(this.currentTierId);
    }

    return document.querySelector('.js-combo-tier.is-active') || document.querySelector('.js-combo-tier');
  }

  applyTierSettings(tier) {
    if (!tier) return;

    const maxSlots = parseInt(tier.dataset.maxSlots || '3', 10);
    const minimumItems = parseInt(tier.dataset.minItems || '3', 10);
    const discountPercentage = parseFloat(tier.dataset.discountPercentage || '20');
    const tierPrice = parseInt(tier.dataset.tierPrice || '0', 10);

    this.maxSlots = Number.isFinite(maxSlots) && maxSlots > 0 ? maxSlots : 3;
    this.minimumItems = Number.isFinite(minimumItems) && minimumItems > 0
      ? Math.min(minimumItems, this.maxSlots)
      : Math.min(3, this.maxSlots);
    this.discountPercentage = Number.isFinite(discountPercentage) && discountPercentage > 0 ? discountPercentage : 20;
    this.tierPrice = Number.isFinite(tierPrice) ? tierPrice : 0;
    this.discountCode = tier.dataset.discountCode || '';
  }

  handleTabClick(tab) {
    if (tab.disabled) return;
    const targetId = tab.dataset.target;

    document.querySelectorAll('.js-tier-tab').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    const targetTier = this.getTierById(targetId);
    document.querySelectorAll('.js-combo-tier').forEach(tier => {
      if (tier.dataset.tierId === targetId) {
        tier.classList.add('is-active');
      } else {
        tier.classList.remove('is-active');
      }
    });

    if (!this.currentTierId || this.currentTierId === targetId) {
      this.applyTierSettings(targetTier);
      this.updateUI();
    }
  }

  async handleAtbClick(btn) {
    if (this.nativeUtsavCollection) return;
    const tier = btn.closest('.combo-tier');
    const tierId = tier.dataset.tierId;
    const variantId = btn.dataset.variantId;

    if (this.currentTierId && this.currentTierId !== tierId) {
      alert('Please complete or clear your current combo before switching tiers.');
      return;
    }

    const productId = btn.dataset.productId;
    const price = parseInt(btn.dataset.price, 10);
    const image = btn.dataset.image;
    const title = btn.dataset.title;
    const handle = btn.dataset.handle;

    const index = this.combo.findIndex(item => item.variantId === variantId);

    if (index > -1) {
      const removedItem = this.combo[index];
      this.combo.splice(index, 1);
      btn.classList.remove('is-added');
      btn.textContent = 'Add To Box';
      if (this.combo.length === 0) this.currentTierId = null;
      this.adjustGlobalCartCount(-1);
      this.updateUI();

      try {
        const remRes = await fetch('/cart/change.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });

        if (!remRes.ok) {
          throw new Error('Failed to remove combo item.');
        }
      } catch (error) {
        console.error(error);
        this.combo.splice(index, 0, removedItem);
        this.currentTierId = tierId;
        btn.classList.add('is-added');
        btn.textContent = 'Added To Box';
        this.adjustGlobalCartCount(1);
        this.updateUI();
        alert('Could not update the box. Please try again.');
      }
    } else {
      this.applyTierSettings(tier);
      const tierSlots = this.maxSlots;

      if (this.combo.length < tierSlots) {
        const wasEligibleForDiscount = this.combo.length >= this.minimumItems;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        try {
          this.currentTierId = tierId;
          this.combo.push({ productId, variantId, price, image, title, handle, tierId });
          btn.classList.add('is-added');
          btn.textContent = 'Added To Box';
          this.adjustGlobalCartCount(1);
          this.updateUI();

          const addRes = await fetch('/cart/add.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_combo': 'true', '_tier_id': tierId } }] })
          });

          if (!addRes.ok) {
            throw new Error('Could not add item to cart.');
          }
          if (!wasEligibleForDiscount && this.combo.length >= this.minimumItems) {
            const eligibleSubtotal = this.combo.reduce((sum, item) => sum + item.price, 0);
            const unlockedSavings = Math.round((eligibleSubtotal * this.discountPercentage) / 100);
            this.showComboCelebration(unlockedSavings);
          }
        } catch (e) {
          console.error(e);
          this.combo = this.combo.filter(item => item.variantId !== variantId);
          btn.classList.remove('is-added');
          btn.textContent = 'Add To Box';
          if (this.combo.length === 0) this.currentTierId = null;
          this.adjustGlobalCartCount(-1);
          this.updateUI();
          alert('Could not add item to cart. Please try again.');
        } finally {
          btn.disabled = false;
        }
      } else {
        alert(`You can only add up to ${tierSlots} items for this combo.`);
      }
    }
  }

  showComboCelebration(savingsAmount) {
    if (!this.celebration || !this.celebrationAmount || savingsAmount <= 0) return;

    window.clearTimeout(this.celebrationTimer);
    if (this.savingsAnimationFrame) {
      window.cancelAnimationFrame(this.savingsAnimationFrame);
      this.savingsAnimationFrame = null;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.buildConfetti(reducedMotion ? 0 : 30);
    this.celebrationAmount.textContent = reducedMotion ? this.formatMoney(savingsAmount) : this.formatMoney(0);
    this.celebration.hidden = false;
    this.celebration.classList.remove('is-active');
    void this.celebration.offsetWidth;
    this.celebration.classList.add('is-active');

    if (!reducedMotion) this.animateSavingsAmount(savingsAmount);

    this.celebrationTimer = window.setTimeout(() => {
      this.celebration.classList.remove('is-active');
      window.setTimeout(() => {
        this.celebration.hidden = true;
        if (this.confettiContainer) this.confettiContainer.innerHTML = '';
      }, reducedMotion ? 0 : 220);
    }, reducedMotion ? 1800 : 2700);
  }

  animateSavingsAmount(savingsAmount) {
    const startedAt = window.performance.now();
    const duration = 900;

    const updateAmount = now => {
      const progress = Math.min((now - startedAt) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      this.celebrationAmount.textContent = this.formatMoney(Math.round(savingsAmount * easedProgress));

      if (progress < 1) {
        this.savingsAnimationFrame = window.requestAnimationFrame(updateAmount);
      } else {
        this.savingsAnimationFrame = null;
      }
    };

    this.savingsAnimationFrame = window.requestAnimationFrame(updateAmount);
  }

  buildConfetti(pieceCount) {
    if (!this.confettiContainer) return;
    this.confettiContainer.innerHTML = '';
    const colors = ['#c8a24a', '#543e3a', '#2d7a45', '#b86f52', '#f1d89a'];

    for (let index = 0; index < pieceCount; index += 1) {
      const piece = document.createElement('span');
      const angle = (Math.PI * 2 * index) / pieceCount + (Math.random() * 0.35);
      const distance = 120 + (Math.random() * 150);
      const x = Math.cos(angle) * distance;
      const y = (Math.sin(angle) * distance) + 70;
      piece.className = index % 3 === 0 ? 'combo-confetti-piece is-round' : 'combo-confetti-piece';
      piece.style.setProperty('--confetti-x', `${x.toFixed(1)}px`);
      piece.style.setProperty('--confetti-y', `${y.toFixed(1)}px`);
      piece.style.setProperty('--confetti-rotation', `${Math.round(360 + (Math.random() * 620))}deg`);
      piece.style.setProperty('--confetti-delay', `${Math.round(Math.random() * 120)}ms`);
      piece.style.backgroundColor = colors[index % colors.length];
      this.confettiContainer.appendChild(piece);
    }
  }

  updateUI() {
    if (this.nativeUtsavCollection) return;
    const tierOnPage = document.querySelector('.js-combo-tier');
    const tierIdOnPage = tierOnPage ? tierOnPage.dataset.tierId : null;
    
    // Filter combo items for this specific page's tier
    const filteredCombo = this.combo.filter(item => !tierIdOnPage || item.tierId === tierIdOnPage);

    // Apply tier settings from current page if possible
    if (tierOnPage) {
       this.applyTierSettings(tierOnPage);
    }

    document.querySelectorAll('.combo-tier').forEach(tier => {
      if (this.currentTierId && tier.dataset.tierId !== this.currentTierId) {
        tier.classList.add('is-disabled');
      } else {
        tier.classList.remove('is-disabled');
      }
    });

    document.querySelectorAll('.js-tier-tab').forEach(tab => {
      if (this.currentTierId && tab.dataset.target !== this.currentTierId) {
        tab.disabled = true;
      } else {
        tab.disabled = false;
      }
    });

    this.syncAddToBoxButtons();
    
    // Safety check for slotsContainer (important for PDP)
    if (this.slotsContainer) {
      this.slotsContainer.innerHTML = '';
      for (let i = 0; i < this.maxSlots; i++) {
        const item = filteredCombo[i];
        const slot = document.createElement('div');
        slot.className = 'combo-slot' + (item ? '' : ' combo-slot--empty');

        if (item) {
          slot.innerHTML = `
            <img src="${item.image}" alt="${item.title}">
            <button type="button" class="combo-slot__remove" data-variant-id="${item.variantId}" aria-label="Remove ${item.title}">×</button>
          `;
          slot.querySelector('.combo-slot__remove').addEventListener('click', (e) => {
            this.removeItem(e.target.dataset.variantId);
          });
        } else {
          slot.innerHTML = `<span class="add-piece">ADD<br>Item ${i + 1}</span>`;
        }
        this.slotsContainer.appendChild(slot);
      }
    }

    const subtotal = filteredCombo.reduce((acc, item) => acc + item.price, 0);
    const qualifiesForDiscount = filteredCombo.length >= this.minimumItems;
    const discountAmount = qualifiesForDiscount
      ? Math.round((subtotal * this.discountPercentage) / 100)
      : 0;
    const finalPriceToDisplay = subtotal - discountAmount;
    const totalRow = document.querySelector('.js-total-row');
    const offerNote = document.querySelector('.js-combo-offer-note');

    if (this.summaryCountEl) {
      this.summaryCountEl.textContent = qualifiesForDiscount
        ? `Your Combo: ${filteredCombo.length} selected`
        : `Your Combo: ${filteredCombo.length} of ${this.minimumItems} selected`;
    }
    if (this.summaryMessageEl) {
      if (qualifiesForDiscount) {
        this.summaryMessageEl.textContent = `${this.discountPercentage}% unlocked`;
      } else {
        const remaining = Math.max(this.minimumItems - filteredCombo.length, 0);
        this.summaryMessageEl.textContent = `Add ${remaining} more to unlock ${this.discountPercentage}% off`;
      }
    }

    this.updateProgress(subtotal, qualifiesForDiscount);

    if (qualifiesForDiscount) {
      const formattedPrice = this.formatMoney(finalPriceToDisplay);
      const formattedSubtotal = this.formatMoney(subtotal);
      const formattedSavings = this.formatMoney(discountAmount);
      if (this.totalPriceEl) {
        this.totalPriceEl.textContent = formattedPrice;
      }
      if (this.totalLabelEl) {
        this.totalLabelEl.textContent = this.isMobileViewport()
          ? 'Total'
          : `Total (${this.discountPercentage}% OFF) -`;
      }
      if (this.totalCompareEl) {
        this.totalCompareEl.textContent = formattedSubtotal;
        this.totalCompareEl.removeAttribute('hidden');
      }
      if (this.totalSavingEl) {
        this.totalSavingEl.textContent = `Save ${formattedSavings}`;
        this.totalSavingEl.removeAttribute('hidden');
      }
      if (totalRow) totalRow.style.display = 'flex';
      if (this.checkoutBtn) {
        this.checkoutBtn.disabled = false;
        this.checkoutBtn.textContent = this.isMobileViewport()
          ? 'CONFIRM COMBO'
          : 'CONFIRM COMBO - 20% OFF';
      }
      if (offerNote) {
        offerNote.textContent = `${this.discountPercentage}% instant discount unlocked. Offer valid till 19 July.`;
      }

      // Save discount state for cart popup banner
      sessionStorage.setItem('comboDiscount', JSON.stringify({
        subtotal,
        discountAmount,
        finalPrice: finalPriceToDisplay,
        discountPercentage: this.discountPercentage
      }));
      this.injectComboDiscountBanner();
    } else {
      if (this.totalPriceEl) this.totalPriceEl.textContent = '---';
      if (this.totalLabelEl) this.totalLabelEl.textContent = 'Total -';
      if (this.totalCompareEl) {
        this.totalCompareEl.textContent = '';
        this.totalCompareEl.setAttribute('hidden', '');
      }
      if (this.totalSavingEl) {
        this.totalSavingEl.textContent = '';
        this.totalSavingEl.setAttribute('hidden', '');
      }
      if (totalRow) totalRow.style.display = 'none';
      if (this.checkoutBtn) {
        this.checkoutBtn.disabled = true;
        this.checkoutBtn.textContent = this.buildDisabledCtaLabel();
      }
      if (offerNote) {
        const remaining = Math.max(this.minimumItems - filteredCombo.length, 0);
        offerNote.textContent = remaining === this.minimumItems
          ? `Add ${this.minimumItems} products across categories to unlock ${this.discountPercentage}% instant discount.`
          : `Add ${remaining} more product${remaining === 1 ? '' : 's'} to unlock ${this.discountPercentage}% instant discount.`;
      }

      // Clear discount state
      sessionStorage.removeItem('comboDiscount');
      this.injectComboDiscountBanner();
    }

    if (this.footer) {
      if (filteredCombo.length > 0) {
        this.footer.classList.add('is-visible');
      } else {
        this.footer.classList.remove('is-visible');
      }
      document.body.classList.toggle('combo-footer-visible', filteredCombo.length > 0);
    }
  }

  watchCartForComboDiscount() {
    if (this.nativeUtsavCollection) return;
    const self = this;

    // Watch product list area – fires when generateCart() re-renders items
    const cartContent = document.querySelector('.js-mini-cart-content');
    if (cartContent) {
      new MutationObserver(() => {
        requestAnimationFrame(() => self.injectComboDiscountBanner());
      }).observe(cartContent, { childList: true });
    }

    // Watch cart total text – fires when updateElements() refreshes the price
    const cartTotalEl = document.querySelector('.js-cart-total');
    if (cartTotalEl) {
      new MutationObserver(() => {
        requestAnimationFrame(() => self.injectComboDiscountBanner());
      }).observe(cartTotalEl, { childList: true, subtree: true, characterData: true });
    }
  }

  injectComboDiscountBanner() {
    if (this.nativeUtsavCollection) return;
    // Remove any stale banner first
    document.querySelectorAll('.combo-cart-discount-banner').forEach(el => el.remove());

    const raw = sessionStorage.getItem('comboDiscount');
    if (!raw) return;

    const { subtotal, discountAmount, finalPrice, discountPercentage } = JSON.parse(raw);

    const bottomTotal = document.querySelector('.bottom-total');
    if (!bottomTotal) return;

    // Override the Shopify-rendered total with discounted price
    const cartTotalEl = document.querySelector('.js-cart-total');
    if (cartTotalEl && !cartTotalEl.dataset.comboOverridden) {
      cartTotalEl.dataset.comboOverridden = 'true';
      cartTotalEl.innerHTML = this.formatMoney(finalPrice);
      setTimeout(() => { delete cartTotalEl.dataset.comboOverridden; }, 100);
    }

    // Build and inject the banner above the total row
    const banner = document.createElement('div');
    banner.className = 'combo-cart-discount-banner';
    banner.innerHTML = `
      <div class="combo-cart-discount-row">
        <span class="combo-cart-badge">🎁 COMBO ${discountPercentage}% OFF</span>
        <span class="combo-cart-saving">You save ${this.formatMoney(discountAmount)}</span>
      </div>
      <div class="combo-cart-original">
        Original: <s>${this.formatMoney(subtotal)}</s> → <strong>${this.formatMoney(finalPrice)}</strong>
      </div>
    `;
    bottomTotal.parentNode.insertBefore(banner, bottomTotal);
  }

  updateProgress(subtotal, qualifiesForDiscount) {
    document.querySelectorAll('.combo-progress-wrapper').forEach(wrapper => {
      const fill = wrapper.querySelector('.combo-progress-fill');
      const text = wrapper.querySelector('.combo-progress-text');

      if (fill) {
        fill.style.width = '0%';
        fill.style.background = '#228be6';
      }

      if (text) {
        text.textContent = `Add ${this.minimumItems} items to unlock ${this.discountPercentage}% OFF.`;
      }
    });

    const activeTier = this.getActiveTierElement();
    if (!activeTier) return;

    const progressText = activeTier.querySelector('.combo-progress-text');
    const progressFill = activeTier.querySelector('.combo-progress-fill');
    if (!progressText || !progressFill) return;

    const progressTarget = Math.max(this.minimumItems, 1);
    const percent = Math.min((this.combo.length / progressTarget) * 100, 100);
    progressFill.style.width = `${percent}%`;

    if (qualifiesForDiscount) {
      const remainingSlots = Math.max(this.maxSlots - this.combo.length, 0);
      const extraCopy = remainingSlots > 0
        ? ` Add ${remainingSlots} more item${remainingSlots === 1 ? '' : 's'} and keep the discount.`
        : '';
      progressText.textContent = `${this.discountPercentage}% OFF unlocked on ${this.formatMoney(subtotal)}.${extraCopy}`;
      progressFill.style.background = '#00b84c';
      return;
    }

    const remainingToUnlock = Math.max(this.minimumItems - this.combo.length, 0);
    progressText.textContent = `Add ${remainingToUnlock} more item${remainingToUnlock === 1 ? '' : 's'} to unlock ${this.discountPercentage}% OFF.`;
  }

  buildDisabledCtaLabel() {
    const remaining = Math.max(this.minimumItems - this.combo.length, 0);

    if (remaining <= 0) {
      return 'GO TO CART';
    }

    if (this.combo.length === 0) {
      return `ADD ${this.minimumItems} PRODUCTS`;
    }

    return `ADD ${remaining} MORE PRODUCT${remaining === 1 ? '' : 'S'}`;
  }

  isMobileViewport() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  async removeItem(variantId) {
    const index = this.combo.findIndex(item => item.variantId === variantId);
    if (index > -1) {
      const [removedItem] = this.combo.splice(index, 1);
      const btn = document.querySelector(`.js-atb-btn[data-variant-id="${variantId}"]`);
      if (btn) {
        btn.classList.remove('is-added');
        btn.textContent = 'Add To Box';
      }
      if (this.combo.length === 0) this.currentTierId = null;
      this.adjustGlobalCartCount(-1);
      this.updateUI();

      try {
        const remRes = await fetch('/cart/change.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });

        if (!remRes.ok) {
          throw new Error('Failed to remove combo item.');
        }
      } catch (error) {
        console.error(error);
        this.combo.splice(index, 0, removedItem);
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = 'Added To Box';
        }
        if (!this.currentTierId) {
          this.currentTierId = this.getActiveTierElement()?.dataset.tierId || null;
        }
        this.adjustGlobalCartCount(1);
        this.updateUI();
        alert('Could not update the box. Please try again.');
      }
    }
  }

  setGlobalCartCount(itemCount) {
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = itemCount;
      el.classList.toggle('hide', itemCount <= 0);
    });
  }

  adjustGlobalCartCount(delta) {
    const currentCountEl = document.querySelector('.js-cart-count');
    const currentCount = currentCountEl ? parseInt(currentCountEl.textContent || '0', 10) : 0;
    const nextCount = Math.max((Number.isFinite(currentCount) ? currentCount : 0) + delta, 0);
    this.setGlobalCartCount(nextCount);
  }

  async updateGlobalCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.setGlobalCartCount(cart.item_count);
    } catch (e) {
      console.error('Failed to update cart count', e);
    }
  }

  formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  async handleCheckout() {
    if (this.combo.length < this.minimumItems) return;

    this.openConfirmDialog();
  }

  async completeCheckout() {
    if (this.combo.length < this.minimumItems || this.isCheckingOut) return;

    this.isCheckingOut = true;
    const confirmButton = this.confirmDialog?.querySelector('[data-combo-confirm-submit]');
    this.checkoutBtn.disabled = true;
    this.checkoutBtn.textContent = 'OPENING CART...';
    if (confirmButton) {
      confirmButton.disabled = true;
      confirmButton.textContent = 'Opening cart...';
    }
    this.closeOverlay(this.confirmDialog);

    try {
      if (typeof window.KpOpenCartDrawer !== 'function') {
        throw new Error('The cart drawer is not available yet. Please try again.');
      }
      await window.KpOpenCartDrawer();
    } catch (error) {
      console.error('Could not open the cart drawer', error);
      if (confirmButton) confirmButton.textContent = 'Please try again';
    }

    setTimeout(() => {
      this.isCheckingOut = false;
      this.checkoutBtn.disabled = false;
      this.checkoutBtn.textContent = this.isMobileViewport()
        ? 'CONFIRM COMBO'
        : 'CONFIRM COMBO - 20% OFF';
      if (confirmButton) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirm & view cart';
      }
    }, 1500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.comboPage = new ComboPage();
});
